export const BUSINESS = {
  name: "Cyber Repair Corp",
  short_name: "Cyber Repair",
  tagline: {
    es: "Reparación profesional · a domicilio y en sitio",
    en: "Pro repair · at home and in shop",
  },
  owner: {
    name: "Ing. Darwin Aguirre",
    role: {
      es: "Microsoldadura · Técnico certificado",
      en: "Microsoldering Technician",
    },
  },
  phone_raw: "+17546109120",
  phone_display: "+1 (754) 610-9120",
  whatsapp_number: "17546109120",
  whatsapp_msg: {
    es: "Hola Cyber Repair Corp, necesito ayuda con mi dispositivo.",
    en: "Hi Cyber Repair Corp, I need help with my device.",
  },
  email: "cyberrepaircorp@gmail.com",
  address: {
    street: "4424 Inverrary Boulevard",
    city: "Lauderhill",
    state: "FL",
    zip: "33319",
    country: "USA",
    full: "4424 Inverrary Boulevard, Lauderhill, FL 33319",
    maps_query: "4424 Inverrary Boulevard, Lauderhill, FL 33319",
  },
  hours: {
    es: [
      { days: "Lun – Vie", time: "10:00 AM – 9:00 PM" },
      { days: "Sábado", time: "10:00 AM – 8:00 PM" },
      { days: "Domingo", time: "Cerrado" },
    ],
    en: [
      { days: "Mon – Fri", time: "10:00 AM – 9:00 PM" },
      { days: "Saturday", time: "10:00 AM – 8:00 PM" },
      { days: "Sunday", time: "Closed" },
    ],
  },
  coverage_radius_mi: 25,
  coverage_radius_km: 40,
  coverage_center: { lat: 26.161, lng: -80.221 }, // Lauderhill, FL 33319
  warranty_days: 30,
  extras: {
    es: ["Reparación de celulares", "Tablets", "Computadoras y laptops", "Consolas de video juego", "Venta al mayor y detal", "Microsoldadura especializada"],
    en: ["Cellphone repair", "Tablets", "Computers and laptops", "Video game consoles", "Wholesale and retail", "Specialized microsoldering"],
  },
  brand_marks: ["Apple", "Samsung", "Sony", "Microsoft", "Nintendo", "Google"],
};

export const REVIEWS = [
  {
    name: "Maria G.",
    device: "iPhone 13 · pantalla",
    stars: 5,
    text: {
      es: "El Ing. Darwin arregló mi iPhone en menos de una hora. Trabajo impecable y precio justo.",
      en: "Darwin fixed my iPhone in under an hour. Impeccable work and fair pricing.",
    },
  },
  {
    name: "Robert K.",
    device: "PS5 · puerto HDMI",
    stars: 5,
    text: {
      es: "Rescataron mi PS5 con microsoldadura cuando otros dijeron que era imposible.",
      en: "They saved my PS5 with microsoldering when others said it was hopeless.",
    },
  },
  {
    name: "Ana L.",
    device: "MacBook · logic board",
    stars: 5,
    text: {
      es: "Diagnóstico gratuito, presupuesto claro y entrega en 48h. Súper recomendados.",
      en: "Free diagnosis, clear quote, delivered in 48h. Highly recommended.",
    },
  },
];
